<script setup lang="ts">
const emit = defineEmits<{
  (e: 'toggleDrawer'): void
}>()

const toggleDrawer = (): void => {
  emit('toggleDrawer')
}
</script>

<template>
  <v-app-bar>
    <!-- Sidebar toggle button -->
    <template #prepend>
      <v-btn @click="toggleDrawer" icon>
        <v-icon icon="PhSidebar" size="20" />
      </v-btn>
    </template>
  </v-app-bar>
</template>
